
import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "Profil",
    dangerZone: "Zone dangereuse",
    deleteAccount: "Supprimer le compte",
    confirmDelete: "Confirmer la suppression",
    deleteWarning: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
    confirmDeleteButton: "Supprimer le compte",
    accountDeleted: "Compte supprimé",
    accountDeletedMessage: "Votre compte a été supprimé avec succès."
  },
  common: {
    cancel: "Annuler",
    delete: "Supprimer",
    deleteConfirmation: "Confirmation de suppression",
    deleteConfirmationMessage: "Êtes-vous sûr de vouloir supprimer"
  }
};
